export enum UserActionType {
    /** exit by tutor */
    ignore,
    /** router navigation request */
    navigateTo,
    /** start the search of policies with acutal answers */
    startSearch,
    /** request to go to the question */
    goToQuestion,
    /** Request to exclude some companies from search */
    excludeSomeCompanies,
    /** Restart the survey */
    restart,
    /** Activate tutor mode */
    activateTutor,
    /** Deactivate tutor mode */
    deactivateTutor,
    /** Request to register */
    register,
    /** Request to login */
    login,
    /** Forgotten Password */
    forgottenPassword
}